export const SELECT_LABEL = {
  make: "OEM Aircraft Make",
  model: "OEM Aircraft Model",
  tail: "Aircraft Tail Number",
  serial: "Aircraft Serial Number",
};

export const SELECT_PLACEHOLDER = {
  make: "Select Aircraft Make",
  model: "Select Aircraft Model",
  tail: "Enter Tail Number",
  serial: "Enter Serial Number",
};

export const BUTTON_CONTENT = {
  back: "Back",
  next: "NEXT",
};

export const HEADING_TEXT = {
  confirmMsg: " Add New  Aircraft",
};

export const WINDSHEAR_TEXT = { predictiveWindshear: "Predictive WindShear" };
